import clsx from 'clsx'
import React from 'react'

import { getCheapestPrices } from '@/features/product-services/lib/getCheapestPrice'

import { formatPrice } from '@/shared/lib/utils/price/format-price'

import { CardIcon } from '../../assets/CardIcon'
import { ShieldIcon } from '../../assets/ShieldIcon'
import { scrollToTabSection } from '../../lib/scrollToTabSection'
import { TService } from '../../lib/types'

import cl from './ProductServices_Info.module.scss'

type ProductAcsProps = {
	services: TService[]
	isCart?: boolean
	onClick?: () => void
}

const TABS_ID_ATTR = `productTabs`

export const ProductServices_Info = ({ services, isCart, onClick = () => null }: ProductAcsProps): JSX.Element => {
	const serviceShortList = getCheapestPrices(services)

	const handleCardClick = (sectionId: string): void => {
		onClick()
		if (!isCart) scrollToTabSection(TABS_ID_ATTR, `tab-pane-services`, -0)
		setTimeout(() => {
			document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: `center` })
		}, 400)
	}

	return !!serviceShortList.length ? (
		<section className={clsx(cl.productServices, { [cl.cartServices]: isCart })}>
			<div className={clsx(cl.root, cl.acs_button)}>
				{!isCart && <p className={cl.title}>Добавить услуги</p>}

				{serviceShortList[0] && (
					<div
						className={cl.item}
						datatype="serviceCard"
						onClick={() => {
							handleCardClick(`services`)
						}}>
						<div className={cl.wrap}>
							<ShieldIcon />
							<p>Страхование устройства</p>
						</div>
						<span className={cl.item__price}> от {formatPrice(serviceShortList[0])}</span>
					</div>
				)}
				{serviceShortList[1] && (
					<div
						className={cl.item}
						datatype="serviceCard"
						onClick={() => {
							handleCardClick(`cards`)
						}}>
						<div className={cl.wrap}>
							<CardIcon />
							<p>Привилегии c iPort+</p>
						</div>
						<span className={cl.item__price}> от {formatPrice(serviceShortList[1])}</span>
					</div>
				)}
			</div>
		</section>
	) : (
		<></>
	)
}
